export default "/latin-ext.511ce967-945a22.woff2";